<template>
<div class="article-sub-header">
    <div class="sub-header">
        <span v-if="widgetConfig.SubheadText" :class="[widgetConfig.SubheadSize == headerSize.MEDIUM ? 'sub-header-medium' : 'sub-header-small']"> {{widgetConfig.SubheadText}} </span>
        <div class="divider-line"></div>
    </div>
    <div class="body-text">
       <span v-if="widgetConfig.BodyText"><p v-html="widgetConfig.BodyText"></p></span>
    </div>
</div>
    
</template>

<script>
export default {
    name: "ArticleSubHead",
    data(){
        return{
            headerSize: {
                SMALL: 'Small',
                MEDIUM: 'Medium'
            }
        }
    },
    props: {
        widgetConfig: Object
    },
}
</script>

<style lang="scss" scoped>
.article-sub-header {
    margin: 24px 15px;
    display: flex;
    
    .sub-header{
        width: 314px;
        color: #000000;        
        margin-right: 24px;
    }
    .sub-header-medium{
        font-weight: 300;
        font-size: 26px;
        line-height: 36px;
    }

    .sub-header-small {
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 32px;
        
    }


    .divider-line {
        width: 120px;
        margin: 16px 0 0 0;
        border-bottom: 5px solid $red-primary;
    }

    .body-text {
        width: 652px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 26px;
    }

}

@include wide-mobile {

    .article-sub-header {
        display: flex;
        flex-direction: column;

        .sub-header-medium{
            margin: 16px 0px 0 0;
        }


        .body-text {
            width: 100%;
            margin: 24px 0 auto 0;
        }

    }
}
</style>
